export default function (tns) {
  const galleries = Array.from(document.querySelectorAll('.vst-slideshow'))

  galleries.forEach((gallery) => {
    tns({
      container: gallery,
      items: 1,
      controlsPosition: 'bottom',
      controlsText: ['&lt;', '&gt;'],
    })
  })
}
